import classNames from 'classnames';
import { Link } from 'react-router-dom';

import logoDark from '@/assets/images/astrihub-dark-transparente.png';
import logoLight from '@/assets/images/astrihub-light-transparente.png';
import { useThemeStore } from '@/stores/useThemeStore';

import styles from './style.module.less';

type AstriHubLogoProps = {
  // `full` is the whole logo; `icon` crops it to the symbol, for the collapsed menu and mobile.
  variant?: 'full' | 'icon';
  className?: string;
  // When given, the logo is a link to this address (the home of the person).
  to?: string;
};

export const AstriHubLogo = ({ variant = 'full', className, to }: AstriHubLogoProps) => {
  const isDarkMode = useThemeStore((state) => state.theme === 'dark');
  const src = isDarkMode ? logoDark : logoLight;

  const logo =
    variant === 'icon' ? (
      <span className={classNames(styles.icon, className)}>
        <img src={src} alt="Astri" className={styles.iconImage} />
      </span>
    ) : (
      <img src={src} alt="AstriHub" className={classNames(styles.full, className)} />
    );

  // `display: contents` keeps the link out of the layout, so the logo sits where it did.
  return to ? (
    <Link to={to} style={{ display: `contents` }}>
      {logo}
    </Link>
  ) : (
    logo
  );
};
